// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Lato:wght@300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: "Lato", sans-serif;
  background: linear-gradient(150deg, #fff0ec 0%, #ffdde8 50%, #fff0ec 100%);
  min-height: 100vh;
  color: #5c2d3e;
}

button {
  color: inherit;
  font-family: inherit;
  border: none;
  cursor: pointer;
}

/* ── Layout ── */

.app-layout {
  display: flex;
  min-height: 100vh;
}

/* ── Sidebar ── */

.sidebar {
  width: 210px;
  min-width: 210px;
  background: linear-gradient(180deg, #6e2040 0%, #8c3055 100%);
  padding: 36px 14px 24px;
  display: flex;
  flex-direction: column;
  gap: 0;
  box-shadow: 4px 0 24px rgba(110, 32, 64, 0.3);
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  transition: left 0.3s ease;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(212, 168, 83, 0.35);
  padding-bottom: 12px;
}

.sidebar-title {
  font-family: "Playfair Display", serif;
  color: #ffd6e4;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
  margin-bottom: 0;
}

.sidebar-close-btn {
  display: none;
  background: transparent;
  border: none;
  color: #ffd6e4;
  font-size: 18px;
  cursor: pointer;
  padding: 2px 6px;
  line-height: 1;
  border-radius: 4px;
  transition: background 0.15s ease;
}

.sidebar-close-btn:hover {
  background: rgba(255, 214, 228, 0.15);
}

.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 99;
}

/* ── Mobile Header ── */

.mobile-header {
  display: none;
  width: 100%;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.hamburger-btn {
  background: transparent;
  border: 1.5px solid #c0607a;
  color: #6e2040;
  font-size: 20px;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  line-height: 1;
  transition: background 0.15s ease;
}

.hamburger-btn:hover {
  background: rgba(110, 32, 64, 0.08);
}

.mobile-filter-badge {
  font-size: 13px;
  color: #8c3055;
  background: #ffe0ec;
  border: 1px solid #e8a8bc;
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 600;
}

.tag-filter-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1 1;
}

.tag-filter-item {
  background: transparent;
  border: 1px solid rgba(255, 214, 228, 0.35);
  color: #f5c0d0;
  padding: 7px 12px;
  border-radius: 20px;
  font-size: 12.5px;
  font-family: "Lato", sans-serif;
  cursor: pointer;
  text-align: left;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease;
}

.tag-filter-item:hover {
  background: rgba(255, 214, 228, 0.15);
  border-color: rgba(255, 214, 228, 0.65);
  color: #ffe0ec;
}

.tag-filter-item--active {
  background: #ffd6e4;
  color: #6e2040;
  border-color: #ffd6e4;
  font-weight: 700;
}

.tag-filter-item--active:hover {
  background: #ffbdd0;
  color: #6e2040;
  border-color: #ffbdd0;
}

.clear-filters-button {
  margin-top: 16px;
  background: transparent;
  border: 1px solid rgba(255, 214, 228, 0.4);
  color: #f5c0d0;
  padding: 7px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-family: "Lato", sans-serif;
  cursor: pointer;
  text-align: center;
  letter-spacing: 0.5px;
  transition: background 0.18s ease;
}

.clear-filters-button:hover {
  background: rgba(255, 214, 228, 0.15);
}

/* ── Main Content ── */

.main-content {
  flex: 1 1;
  padding: 56px 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-title {
  font-family: "Playfair Display", serif;
  font-size: 54px;
  font-weight: 700;
  color: #6e2040;
  margin-bottom: 36px;
  letter-spacing: 1px;
  text-align: center;
  text-shadow: 1px 2px 6px rgba(110, 32, 64, 0.15);
}

/* ── Date Card ── */

.date-card {
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(6px);
  border-radius: 18px;
  border: 1px solid rgba(140, 48, 85, 0.15);
  box-shadow:
    0 2px 4px rgba(110, 32, 64, 0.06),
    0 8px 24px rgba(110, 32, 64, 0.16),
    0 24px 56px rgba(110, 32, 64, 0.13);
  padding: 36px 44px;
  max-width: 580px;
  width: 100%;
  opacity: 1;
  transform: translateY(0);
  transition:
    opacity 0.28s ease,
    transform 0.28s ease;
}

.date-card--hidden {
  opacity: 0;
  transform: translateY(12px);
}

.date-title {
  font-family: "Playfair Display", serif;
  font-size: 30px;
  font-weight: 600;
  color: #6e2040;
  margin-bottom: 10px;
}

.date-description {
  font-size: 16px;
  color: #7a4054;
  margin-bottom: 22px;
  line-height: 1.65;
  font-weight: 300;
}

.date-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 22px;
}

.date-tag {
  display: inline-block;
  background-color: #ffe0ec;
  color: #6e2040;
  padding: 5px 13px;
  border-radius: 16px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid #e8a8bc;
  transition:
    background 0.18s ease,
    color 0.18s ease;
}

.date-tag:hover {
  background-color: #e8a8bc;
  color: #4a1028;
}

.date-tag--active {
  background-color: #8c3055;
  color: #ffe0ec;
  border-color: #6e2040;
}

.date-tag--active:hover {
  background-color: #6e2040;
  color: #ffe0ec;
}

.date-budget {
  font-size: 14.5px;
  color: #7a4054;
}

.budget-label {
  font-weight: 700;
  color: #6e2040;
}

/* ── Button ── */

.next-date-button {
  background: linear-gradient(135deg, #8c3055 0%, #6e2040 100%);
  color: #ffe0ec;
  padding: 13px 32px;
  border-radius: 30px;
  font-size: 16px;
  font-family: "Playfair Display", serif;
  font-weight: 600;
  margin-top: 30px;
  letter-spacing: 1px;
  box-shadow: 0 4px 18px rgba(110, 32, 64, 0.35);
  transition:
    background 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
}

.next-date-button:hover {
  background: linear-gradient(135deg, #a83868 0%, #8c3055 100%);
  box-shadow: 0 6px 24px rgba(110, 32, 64, 0.45);
  transform: translateY(-2px);
}

/* ── Mobile ── */

@media (max-width: 768px) {
  .app-layout {
    flex-direction: column;
  }

  /* Sidebar becomes a fixed slide-in drawer */
  .sidebar {
    position: fixed;
    top: 0;
    left: -230px;
    width: 220px;
    min-width: 220px;
    height: 100vh;
    z-index: 100;
    padding: 28px 14px 24px;
  }

  .sidebar--open {
    left: 0;
  }

  .sidebar-overlay {
    display: block;
  }

  .sidebar-close-btn {
    display: block;
  }

  /* Show hamburger header, hide desktop sidebar from flow */
  .mobile-header {
    display: flex;
  }

  .main-content {
    padding: 28px 20px 48px;
    width: 100%;
  }

  .page-title {
    font-size: 38px;
    margin-bottom: 24px;
  }

  .date-card {
    padding: 24px 22px;
  }

  .date-title {
    font-size: 24px;
  }

  .date-description {
    font-size: 15px;
    margin-bottom: 18px;
  }

  .next-date-button {
    font-size: 15px;
    padding: 12px 26px;
    margin-top: 24px;
    width: 100%;
    max-width: 340px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,0EAA0E;EAC1E,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,kBAAkB;;AAElB;EACE,YAAY;EACZ,gBAAgB;EAChB,6DAA6D;EAC7D,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,WAAW;AACb;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB;;;oBAGkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uBAAuB;;AAEvB;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA,oBAAoB;;AAEpB;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,mBAAmB;EACnB,yCAAyC;EACzC;;;uCAGqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB;;wBAEsB;AACxB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB;;oBAEkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C;;;wBAGsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,iBAAiB;;AAEjB;EACE;IACE,sBAAsB;EACxB;;EAEA,4CAA4C;EAC5C;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,0DAA0D;EAC1D;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Lato:wght@300;400;700&display=swap\");\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Lato\", sans-serif;\n  background: linear-gradient(150deg, #fff0ec 0%, #ffdde8 50%, #fff0ec 100%);\n  min-height: 100vh;\n  color: #5c2d3e;\n}\n\nbutton {\n  color: inherit;\n  font-family: inherit;\n  border: none;\n  cursor: pointer;\n}\n\n/* ── Layout ── */\n\n.app-layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* ── Sidebar ── */\n\n.sidebar {\n  width: 210px;\n  min-width: 210px;\n  background: linear-gradient(180deg, #6e2040 0%, #8c3055 100%);\n  padding: 36px 14px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  box-shadow: 4px 0 24px rgba(110, 32, 64, 0.3);\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n  transition: left 0.3s ease;\n}\n\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  border-bottom: 1px solid rgba(212, 168, 83, 0.35);\n  padding-bottom: 12px;\n}\n\n.sidebar-title {\n  font-family: \"Playfair Display\", serif;\n  color: #ffd6e4;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  letter-spacing: 0.5px;\n  margin-bottom: 0;\n}\n\n.sidebar-close-btn {\n  display: none;\n  background: transparent;\n  border: none;\n  color: #ffd6e4;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 2px 6px;\n  line-height: 1;\n  border-radius: 4px;\n  transition: background 0.15s ease;\n}\n\n.sidebar-close-btn:hover {\n  background: rgba(255, 214, 228, 0.15);\n}\n\n.sidebar-overlay {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 99;\n}\n\n/* ── Mobile Header ── */\n\n.mobile-header {\n  display: none;\n  width: 100%;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.hamburger-btn {\n  background: transparent;\n  border: 1.5px solid #c0607a;\n  color: #6e2040;\n  font-size: 20px;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  line-height: 1;\n  transition: background 0.15s ease;\n}\n\n.hamburger-btn:hover {\n  background: rgba(110, 32, 64, 0.08);\n}\n\n.mobile-filter-badge {\n  font-size: 13px;\n  color: #8c3055;\n  background: #ffe0ec;\n  border: 1px solid #e8a8bc;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-weight: 600;\n}\n\n.tag-filter-list {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  flex: 1;\n}\n\n.tag-filter-item {\n  background: transparent;\n  border: 1px solid rgba(255, 214, 228, 0.35);\n  color: #f5c0d0;\n  padding: 7px 12px;\n  border-radius: 20px;\n  font-size: 12.5px;\n  font-family: \"Lato\", sans-serif;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    background 0.18s ease,\n    border-color 0.18s ease,\n    color 0.18s ease;\n}\n\n.tag-filter-item:hover {\n  background: rgba(255, 214, 228, 0.15);\n  border-color: rgba(255, 214, 228, 0.65);\n  color: #ffe0ec;\n}\n\n.tag-filter-item--active {\n  background: #ffd6e4;\n  color: #6e2040;\n  border-color: #ffd6e4;\n  font-weight: 700;\n}\n\n.tag-filter-item--active:hover {\n  background: #ffbdd0;\n  color: #6e2040;\n  border-color: #ffbdd0;\n}\n\n.clear-filters-button {\n  margin-top: 16px;\n  background: transparent;\n  border: 1px solid rgba(255, 214, 228, 0.4);\n  color: #f5c0d0;\n  padding: 7px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-family: \"Lato\", sans-serif;\n  cursor: pointer;\n  text-align: center;\n  letter-spacing: 0.5px;\n  transition: background 0.18s ease;\n}\n\n.clear-filters-button:hover {\n  background: rgba(255, 214, 228, 0.15);\n}\n\n/* ── Main Content ── */\n\n.main-content {\n  flex: 1;\n  padding: 56px 72px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.page-title {\n  font-family: \"Playfair Display\", serif;\n  font-size: 54px;\n  font-weight: 700;\n  color: #6e2040;\n  margin-bottom: 36px;\n  letter-spacing: 1px;\n  text-align: center;\n  text-shadow: 1px 2px 6px rgba(110, 32, 64, 0.15);\n}\n\n/* ── Date Card ── */\n\n.date-card {\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(6px);\n  border-radius: 18px;\n  border: 1px solid rgba(140, 48, 85, 0.15);\n  box-shadow:\n    0 2px 4px rgba(110, 32, 64, 0.06),\n    0 8px 24px rgba(110, 32, 64, 0.16),\n    0 24px 56px rgba(110, 32, 64, 0.13);\n  padding: 36px 44px;\n  max-width: 580px;\n  width: 100%;\n  opacity: 1;\n  transform: translateY(0);\n  transition:\n    opacity 0.28s ease,\n    transform 0.28s ease;\n}\n\n.date-card--hidden {\n  opacity: 0;\n  transform: translateY(12px);\n}\n\n.date-title {\n  font-family: \"Playfair Display\", serif;\n  font-size: 30px;\n  font-weight: 600;\n  color: #6e2040;\n  margin-bottom: 10px;\n}\n\n.date-description {\n  font-size: 16px;\n  color: #7a4054;\n  margin-bottom: 22px;\n  line-height: 1.65;\n  font-weight: 300;\n}\n\n.date-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 22px;\n}\n\n.date-tag {\n  display: inline-block;\n  background-color: #ffe0ec;\n  color: #6e2040;\n  padding: 5px 13px;\n  border-radius: 16px;\n  font-size: 13px;\n  cursor: pointer;\n  border: 1px solid #e8a8bc;\n  transition:\n    background 0.18s ease,\n    color 0.18s ease;\n}\n\n.date-tag:hover {\n  background-color: #e8a8bc;\n  color: #4a1028;\n}\n\n.date-tag--active {\n  background-color: #8c3055;\n  color: #ffe0ec;\n  border-color: #6e2040;\n}\n\n.date-tag--active:hover {\n  background-color: #6e2040;\n  color: #ffe0ec;\n}\n\n.date-budget {\n  font-size: 14.5px;\n  color: #7a4054;\n}\n\n.budget-label {\n  font-weight: 700;\n  color: #6e2040;\n}\n\n/* ── Button ── */\n\n.next-date-button {\n  background: linear-gradient(135deg, #8c3055 0%, #6e2040 100%);\n  color: #ffe0ec;\n  padding: 13px 32px;\n  border-radius: 30px;\n  font-size: 16px;\n  font-family: \"Playfair Display\", serif;\n  font-weight: 600;\n  margin-top: 30px;\n  letter-spacing: 1px;\n  box-shadow: 0 4px 18px rgba(110, 32, 64, 0.35);\n  transition:\n    background 0.2s ease,\n    box-shadow 0.2s ease,\n    transform 0.15s ease;\n}\n\n.next-date-button:hover {\n  background: linear-gradient(135deg, #a83868 0%, #8c3055 100%);\n  box-shadow: 0 6px 24px rgba(110, 32, 64, 0.45);\n  transform: translateY(-2px);\n}\n\n/* ── Mobile ── */\n\n@media (max-width: 768px) {\n  .app-layout {\n    flex-direction: column;\n  }\n\n  /* Sidebar becomes a fixed slide-in drawer */\n  .sidebar {\n    position: fixed;\n    top: 0;\n    left: -230px;\n    width: 220px;\n    min-width: 220px;\n    height: 100vh;\n    z-index: 100;\n    padding: 28px 14px 24px;\n  }\n\n  .sidebar--open {\n    left: 0;\n  }\n\n  .sidebar-overlay {\n    display: block;\n  }\n\n  .sidebar-close-btn {\n    display: block;\n  }\n\n  /* Show hamburger header, hide desktop sidebar from flow */\n  .mobile-header {\n    display: flex;\n  }\n\n  .main-content {\n    padding: 28px 20px 48px;\n    width: 100%;\n  }\n\n  .page-title {\n    font-size: 38px;\n    margin-bottom: 24px;\n  }\n\n  .date-card {\n    padding: 24px 22px;\n  }\n\n  .date-title {\n    font-size: 24px;\n  }\n\n  .date-description {\n    font-size: 15px;\n    margin-bottom: 18px;\n  }\n\n  .next-date-button {\n    font-size: 15px;\n    padding: 12px 26px;\n    margin-top: 24px;\n    width: 100%;\n    max-width: 340px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
